import styled from 'styled-components';

export const BlueDot = styled.div`
  width: 20px;
  height: 20px;
  background-color: var(--brand-blue);
  border-radius: 100%;
  margin-top: 38px;
`;
